<app-dashboard-admin style="width: inherit;"></app-dashboard-admin>
<section style="background: #f1f1f1; padding-bottom: 4%;">
  <section class="section-css">
    <div class="row">
      <div class="col-sm" style="height: 10px;"></div>
      <div class="col-md" style="height: 20px"></div>
    </div>

    <div class="topnav">
      <a routerLink="dashboardmain-admin"><i class="fa fa-home" aria-hidden="true"></i></a>
      <a style="color: #6c757d;text-decoration: none;"> Settings > <span
          style="color: #337ab7;font-family: 'pt_sans_captionbold';"> Manage Category </span></a>
      <div class="topnav-right">

        <button type="button" class="btn btn-labeled btn-success" (click)="changeStatus('1')"
          style="margin-right: 10px;">
          <span class="btn-label"><i class="fa fa-check-circle" aria-hidden="true"></i></span>&nbsp;Active</button>
        <button type="button" class="btn btn-labeled btn-warning" (click)="changeStatus('0')"
          style="margin-right: 10px;color: white;">
          <span class="btn-label"><i class="fa fa-ban" aria-hidden="true"></i></span>&nbsp;In Active</button>
        <button type="button" class="btn btn-labeled btn-danger" (click)="changeStatus('2')">
          <span class="btn-label"><i class="fa fa-trash" aria-hidden="true"></i></span>&nbsp;Delete</button>
      </div>
    </div>
  </section>
<br>
  <div id="grid" class="grid-styles">
    <div style="color: red;font-size: 13px;padding-left: 17px;">Note&nbsp;:&nbsp;Only perform one action at time either
      Active or In-Active or Delete <span *ngIf="temp.length > 0" class="no-actn-prfmd">No action performed selected
        items {{temp.length}}</span></div>
    <dx-data-grid id="grid-container" [dataSource]="sales" [showBorders]="true"
      (onSelectionChanged)="selectionChanged($event)" style="max-width: 100%;" class="grid-table-styles">
      <dxo-search-panel [visible]="true" [width]="300" placeholder="Search..."></dxo-search-panel>
      <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="NewFileName">
      </dxo-export>
      <dxo-selection [selectAllMode]="allMode" [showCheckBoxesMode]="checkBoxesMode" mode="multiple">Check
      </dxo-selection>
      <dxo-paging [pageSize]="10"></dxo-paging>
      <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[5, 10, 20]"></dxo-pager>
      <!-- <dxo-filter-row [visible]="true"></dxo-filter-row> -->
      <dxi-column caption="S.No" [width]="50" cellTemplate="SerialNoTemplate"></dxi-column>
      <div *dxTemplate="let data of 'SerialNoTemplate'">
        {{data.row.rowIndex + 1}}
      </div>
      <dxi-column dataField="category" caption="Category Name" [width]="400"></dxi-column>
      <dxi-column dataField="status_nm" caption="Status" cellTemplate="cellTemplate" [width]="100"></dxi-column>
      <div *dxTemplate="let cell of 'cellTemplate'">
        <div style="color:green" *ngIf="cell.text == 'Active'">{{cell.text}}</div>
        <div style="color:red" *ngIf="cell.text == 'In-Active'">{{cell.text}}</div>
      </div>
    </dx-data-grid>
  </div>
</section>